(function(){
    document.addEventListener('DOMContentLoaded', function() {
      console.log(123);
      function initSlidersMainProduct() {
        window.sliderProductMain = new Swiper('.slider--main', {
          spaceBetween: 0,
          slidesPerView: 1,
          loop: true,
          grabCursor: false,
          navigation: {
            nextEl: '.swiper-button-next-main',
            prevEl: '.swiper-button-prev-main',
          },
          breakpoints: {
            750: {
              slidesPerView: 1,
              spaceBetween: 10,
              centeredSlides: false,
            },
            990: {
              slidesPerView: 1,
              spaceBetween: 30,
              centeredSlides: false,
            },
          },
        });
    }
    // initSlidersMainProduct();
      
    // document.querySelector('product-info .product-variant-id').addEventListener('change', function(e) {
      
    //   if ( window.variant_data ) {
    //     let variantsData = JSON.parse(window.variant_data);
    //     console.log(variantsData);
    //     let variantId = this.value;
    //     let filteredItems = variantsData.filter(item => item.id === variantId);
    //     if ( ! filteredItems ) return false;
    //     let gallery = filteredItems[0].gallery.replace(/[\[\]']/g, '').split(',');
    //     gallery = gallery.filter(item => item !== '' && item !== null && item !== undefined);
    //     if ( gallery.length < 1 ) return false;
    //     window.sliderProductMain?.destroy();
        
    //     renderNewSlider(gallery, document.querySelector('.product-slider__wrapper .swiper-wrapper'));
       
    //     initSlidersMainProduct();
    //     if ( document.querySelectorAll('.product-slider__wrapper .swiper-slide video') ) {
    //       document.querySelectorAll('.product-slider__wrapper .swiper-slide video').forEach(elem => {
    //         elem.play();
    //       });
    //     }
    //   } else {
    //     let variantId = this.value;
    //     variantImage(variantId);
    //   }
    // });
      
   /**
    * code for change slides in product slide for each variant
    */
    function variantImage(val) {
      var selectedVariantId = parseInt(val, 10);
      const variant = productCur.filter(v => v.id === selectedVariantId);

      if ( variant[0].featured_media.id && $('[date-for-slick]').length > 1 && $('[date-for-slick="' + variant[0].featured_media.id + '"]').length > 0 ) {
        activeMedia = document.querySelector(`[date-for-slick="${variant[0].featured_media.id}"]`).getAttribute('aria-label');
        var numbers = activeMedia.split("/");
        var firstNumber = parseInt(numbers[0]);
        window.galleryMain.slideTo(firstNumber - 1);
        window.galleryMain.slideTo(firstNumber - 1);
      }
    }

    function isValidBase64(str) {
      const base64Pattern = /^[A-Za-z0-9+/]+={0,2}$/;
      return base64Pattern.test(str) && str.length % 4 === 0;
    }
    
    /*
    * render new sliders to main product slider
    */
    function renderNewSlider(gallery, mainSlider) {
      let sliders = document.querySelectorAll('.gallery-main .swiper-slide');
      const firstSlide = mainSlider.querySelector('.swiper-slide:first-child').cloneNode(true);
      if ( sliders ) {
        mainSlider.innerHTML = '';
      }
      gallery.forEach(function(elem) {
        let tempSlide = firstSlide.cloneNode(true);
        // console.log(elem);
        if ( isValidBase64(elem) ) {
          // console.log(atob(elem));
          tempSlide.innerHTML = '<div class="product-media-container media-type-video media-fit-contain global-media-settings gradient" style="--ratio: 1.0; --preview-ratio: 1.0;"><deferred-media class="deferred-media media media--transparent no-js-hidden" data-media-id="50803257114909" loaded="true">' + atob(elem) + '</deferred-media></div>';
        } else {
          tempSlide.querySelector('img').setAttribute('src', elem);
          tempSlide.querySelector('img').setAttribute('srcset', '');
        }
        
        mainSlider.appendChild(tempSlide);
      });
    }
  }, false);
})();